export default {
      id: "icon--snowfun-usage",
      viewBox: "0 0 30.3 31.9",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--snowfun-usage",
      toString: function () {
        return this.url;
      }
    }